module.exports = __webpack_public_path__ + "static/media/eyelash03.a675845b.png";